import Vue from 'vue'
import VueRouter from 'vue-router'
import Store from "../store";
import HttpService from "../service/HttpService";

Vue.use(VueRouter)

const PERFIS_RELATORIOS_PROFICIENCIA_V2 = [
    "Administrador",
    "Professor",
    "Coordernador Escolar",
    "Diretor",
    "Secretário da Educação",
]

const autorizarPerfisRelatorioProficienciaV2 = (to, from, next) => {
    Store.dispatch("Login/getUser").then(response => {
        if (!PERFIS_RELATORIOS_PROFICIENCIA_V2.includes(response.perfil)) {
            next("/401")
        } else {
            next();
        }
    });
}

const routes = [
    {
        path: "*",
        meta: {
            name: "",
            requiresAuth: true
        },
        redirect: {
            path: "/dashboard"
        }
    },
    {
        path: "",
        meta: {
            name: "",
            requiresAuth: true
        },
        component: () => import("../components/global/Layout"),
        children: [
            {
                path: "/",
                meta: {
                    name: "",
                    requiresAuth: true
                },
                name: "",
                component: () => import("../views/Dashboard/Dashboard.vue")
            },
            {
                path: "/perfil",
                meta: {
                    name: "",
                    requiresAuth: true
                },
                name: "",
                component: () => import("../views/Perfil/Perfil")
            },
            {
                path: "/acessos",
                meta: {
                    name: "",
                    requiresAuth: true
                },
                name: "",
                component: () => import("../views/EstatisticaAcesso/EstatisticaAcesso"),
                beforeEnter: (to, from, next) => {
                    Store.dispatch("Login/getUser").then(response => {
                        if (response.perfil != 'Administrador') {
                            next("/401")
                        } else {
                            next();
                        }
                    });
                }
            },
            {
                path: "/relatorios/proficiencia-da-rede",
                meta: {
                    name: "Relatorio Proficiencia da Rede",
                    requiresAuth: true
                },
                name: "",
                component: () => import("../views/Relatorios/RelatorioProficienciaRede")
            },
            {
                path: "/relatorios/proficiencia-da-escola",
                meta: {
                    name: "Relatorio Proficiencia da Escola",
                    requiresAuth: true
                },
                name: "",
                component: () => import("../views/Relatorios/RelatorioProficienciaEscola")
            },
            {
                path: "/relatorios/proficiencia-da-turma",
                meta: {
                    name: "Relatorio Proficiencia da Turma",
                    requiresAuth: true
                },
                name: "",
                component: () => import("../views/Relatorios/RelatorioProficienciaTurma")
            },
            {
                path: "/relatorios/proficiencia-do-aluno",
                meta: {
                    name: "Relatorio Proficiencia do aluno",
                    requiresAuth: true
                },
                name: "",
                component: () => import("../views/Relatorios/RelatorioProficienciaAluno")
            },
            {
                path: "/relatorios/proficiencia-do-aluno-v2",
                meta: {
                    name: "Relatorio Proficiencia do aluno V2",
                    requiresAuth: true
                },
                name: "",
                component: () => import("../views/Relatorios/proficiencia-aluno-v2/FiltroProficienciaAlunoV2.vue"),
                beforeEnter: autorizarPerfisRelatorioProficienciaV2
            },
            {
                path: "/relatorios/proficiencia-da-turma-v2",
                meta: {
                    name: "Relatorio Proficiencia da Turma V2",
                    requiresAuth: true
                },
                name: "",
                component: () => import("../views/Relatorios/proficiencia-turma-v2/FiltroProficienciaTurmaV2.vue"),
                beforeEnter: autorizarPerfisRelatorioProficienciaV2
            },
            {
                path: "/relatorios/proficiencia-da-escola-v2",
                meta: {
                    name: "Relatorio Proficiencia da Escola V2",
                    requiresAuth: true
                },
                name: "",
                component: () => import("../views/Relatorios/proficiencia-escola-v2/FiltroProficienciaEscolaV2.vue"),
                beforeEnter: autorizarPerfisRelatorioProficienciaV2
            },
            {
                path: "/relatorios/proficiencia-da-rede-v2",
                meta: {
                    name: "Relatorio Proficiencia da Rede V2",
                    requiresAuth: true
                },
                name: "",
                component: () => import("../views/Relatorios/proficiencia-rede-v2/FiltroProficienciaRedeV2.vue"),
                beforeEnter: autorizarPerfisRelatorioProficienciaV2
            },
            {
                path: "/relatorios/proficiencia-por-questao",
                meta: {
                    name: "Relatorio Proficiencia por Questao",
                    requiresAuth: true
                },
                name: "",
                component: () => import("../views/Relatorios/proficiencia-questao/FiltroRelatorioProficienciaQuestao.vue")
            },
            {
                path: "/relatorios/proficiencia-por-escola",
                meta: {
                    name: "Relatorio Proficiencia por Escola",
                    requiresAuth: true
                },
                name: "",
                component: () => import("../views/Relatorios/proficiencia-por-escola/FiltroProficienciaPorEscola.vue")
            },
            {
                path: "/relatorios/distribuicao-dos-niveis",
                meta: {
                    name: "Relatorio Distribuicao dos Niveis",
                    requiresAuth: true
                },
                name: "",
                component: () => import("../views/Relatorios/RelatorioDistribuicaoNiveis")
            },
            {
                path: "/relatorios/Escolas-por-quartil",
                meta: {
                    name: "Relatorio Escolas por Quartil",
                    requiresAuth: true
                },
                name: "",
                component: () => import("../views/Relatorios/RelatorioEscolaQuartil")
            },
            {
                path: "/relatorios/quantitativo",
                meta: {
                    name: "Relatorio Quantitativo",
                    requiresAuth: true
                },
                name: "",
                component: () => import("../views/Relatorios/quantitativo/FiltroRelatorioQuantitativo.vue")
            },
            {
                path: "/relatorios/desempenho",
                meta: {
                    name: "Relatorio Desempenho",
                    requiresAuth: true
                },
                name: "",
                component: () => import("../views/Relatorios/RelatorioDesempenho.vue")
            },
            {
                path: "/relatorios/desempenho-turma",
                meta: {
                    name: "Relatorio Desempenho da Turma",
                    requiresAuth: true
                },
                name: "",
                component: () => import("../views/Relatorios/desempenho-turma/FiltroRelatorioDesempenhoTurma.vue")
            },
            {
                path: "/relatorios/rendimento",
                meta: {
                    name: "Relatorio de Rendimento",
                    requiresAuth: true
                },
                name: "",
                component: () => import("../views/Relatorios/rendimento/FiltroRelatorioRendimento.vue")
            },
            {
                path: "/relatorios/participacao",
                meta: {
                    name: "Relatorio de Participacao",
                    requiresAuth: true
                },
                name: "",
                component: () => import("../views/Relatorios/participacao/FiltroRelatorioParticipacao.vue")
            },
            {
                path: "/relatorios/evolucao",
                meta: {
                    name: "Relatorio de Evolucao",
                    requiresAuth: true
                },
                name: "",
                component: () => import("../views/Relatorios/evolucao/FiltroRelatorioEvolucao.vue")
            },
            {
                path: "/relatorios/comparativo-escolas",
                meta: {
                    name: "Relatorio Comparativo de Escolas",
                    requiresAuth: true
                },
                name: "",
                component: () => import("../views/Relatorios/comparativo-escolas/FiltroRelatorioComparativoEscolas.vue")
            },
            {
                path: "/comparativo-escolas",
                redirect: "/relatorios/comparativo-escolas"
            },
            {
                path: "/evolucao",
                redirect: "/relatorios/evolucao"
            },
            {
                path: "/Evolucao",
                redirect: "/relatorios/evolucao"
            },
            {
              path: "/sondagem-infantil",
              meta: {
                  name: "Sondagem Infantil",
                  requiresAuth: true
              },
              name: "",
              component: () => import("../views/SondagemInfantil/SondagemInfantil.vue")
            },
            {
              path: "/quesitos/cadastro",
              meta: {
                  name: "Cadastro Quesitos TCE",
                  requiresAuth: true
              },
              name: "",
              component: () => import("../views/QuesitosTCE/QuesitosTCE.vue")
            },
            {
                path: "/comunicacao/",
                meta: {
                    name: "Comunicações",
                    requiresAuth: true
                },
                name: "",
                component: () => import("../views/Comunicacao/ListaComunicacao.vue")
              },
            {
                path: "/quesitos",
                meta: {
                    name: "Quesitos TCE",
                    requiresAuth: true
                },
                name: "",
                component: () => import("../views/QuesitosTCE/ListarQuesitoCidade.vue")
            },
            {
                path: "/devolutiva",
                meta: {
                    name: "",
                    requiresAuth: true
                },
                component: () => import("../views/Devolutiva/Devolutiva")
            },
            {
                path: "/Laudos",
                meta: {
                    name: "",
                    requiresAuth: true
                },
                component: () => import("../views/Laudos/Laudos")
            },
            {
                path: "/planejamento-acao",
                meta: {
                    name: "",
                    requiresAuth: true
                },
                component: () => import("../views/PlanejamentoAcao/PlanejamentoAcao")
            },
            {
                path: "/Escolas",
                meta: {
                    name: "",
                    requiresAuth: true
                },
                component: () => import("../views/Escolas/Escolas"),
                beforeEnter: (to, from, next) => {
                    Store.dispatch("Login/getUser").then(response => {
                        if (response.perfil != 'Administrador') {
                            next("/401")
                        } else {
                            next();
                        }
                    });
                }
            },
            {
                path: "/alunos",
                meta: {
                    name: "",
                    requiresAuth: true
                },
                component: () => import("../views/Alunos/Alunos"),
                beforeEnter: (to, from, next) => {
                    Store.dispatch("Login/getUser").then(response => {
                        if (response.perfil != 'Administrador' && response.perfil != 'Master') {
                            next("/401")
                        } else {
                            next();
                        }
                    });
                }
            },
            {
                path: "/cidades",
                meta: {
                    name: "",
                    requiresAuth: true
                },
                component: () => import("../views/Master/Cidades/Cidades.vue"),
                beforeEnter: (to, from, next) => {
                    Store.dispatch("Login/getUser").then(response => {
                        if (response.perfil != 'Master') {
                            next("/401")
                        } else {
                            next();
                        }
                    });
                }
            },
            {
                path: "/usuarios",
                meta: {
                    name: "",
                    requiresAuth: true
                },
                component: () => import("../views/Master/Usuarios/Usuarios.vue"),
                beforeEnter: (to, from, next) => {
                    Store.dispatch("Login/getUser").then(response => {
                        if (response.perfil != 'Master') {
                            next("/401")
                        } else {
                            next();
                        }
                    });
                }
            },
            {
                path: "/respostas-alunos",
                meta: {
                    name: "",
                    requiresAuth: true
                },
                component: () => import("../views/Master/RespostasAlunos/RespostasAlunos.vue"),
                beforeEnter: (to, from, next) => {
                    Store.dispatch("Login/getUser").then(response => {
                        if (response.perfil != 'Master') {
                            next("/401")
                        } else {
                            next();
                        }
                    });
                }
            },
            {
                path: "/relatorios/aluno",
                meta: {
                    name: "",
                    requiresAuth: true
                },
                component: () => import("../views/Alunos/AlunoRelatorio")
            },
            {
                path: "/avaliacao",
                meta: {
                    name: "",
                    requiresAuth: true
                },
                component: () => import("../views/Avaliacao/Avaliacao"),
                beforeEnter: (to, from, next) => {
                    Store.dispatch("Login/getUser").then(response => {
                        if (response.perfil != 'Administrador') {
                            next("/401")
                        } else {
                            next();
                        }
                    });
                }
            },
            {
                path: "/Cadernos",
                meta: {
                    name: "",
                    requiresAuth: true
                },
                component: () => import("../views/Cadernos/Cadernos"),
                beforeEnter: (to, from, next) => {
                    Store.dispatch("Login/getUser").then(response => {
                        if (response.perfil != 'Administrador') {
                            next("/401")
                        } else {
                            next();
                        }
                    });
                }
            },
            {
              path: "/noticias",
              meta: {
                  name: "Noticias",
                  requiresAuth: true
              },
              component: () => import("../views/Noticias/Noticias"),
              beforeEnter: (to, from, next) => {
                Store.dispatch("Login/getUser").then(response => {
                    if (response.perfil != 'Master') {
                        next("/401")
                    } else {
                        next();
                    }
                });
              }
            },
            {
                path: "/manuais",
                meta: {
                    name: "",
                    requiresAuth: true
                },
                component: () => import("../views/Manual"),
                beforeEnter: (to, from, next) => {
                    Store.dispatch("Login/getUser").then(response => {
                        if (response.perfil != 'Administrador') {
                            next("/401")
                        } else {
                            next();
                        }
                    });
                }
            },
            {
                path: "/juntar-alunos",
                meta: {
                    name: "",
                    requiresAuth: true
                },
                component: () => import("../views/Alunos/JuntaAlunos.vue"),
                beforeEnter: (to, from, next) => {
                    Store.dispatch("Login/getUser").then(response => {
                        if (response.perfil != 'Administrador') {
                            next("/401")
                        } else {
                            next();
                        }
                    });
                }
            },
            {
                path: "/lancamento-respostas",
                meta: {
                    name: "",
                    requiresAuth: true
                },
                component: () => import("../views/LancamentoRespostas/LancamentoRespostas"),
                beforeEnter: (to, from, next) => {
                    Store.dispatch("Login/getUser").then(response => {
                        if (response.perfil != 'Administrador') {
                            next("/401")
                        } else {
                            next();
                        }
                    });
                }
            },
            {
                path: "/turma",
                meta: {
                    name: "",
                    requiresAuth: true
                },
                component: () => import("../views/Turma/Turma"),
                beforeEnter: (to, from, next) => {
                    Store.dispatch("Login/getUser").then(response => {
                        if (response.perfil != 'Administrador') {
                            next("/401")
                        } else {
                            next();
                        }
                    });
                }
            },
            {
                path: "/cartao-resposta",
                meta: {
                    name: "",
                    requiresAuth: true
                },
                component: () => import("../views/CartaoResposta/CartaoResposta"),
                beforeEnter: (to, from, next) => {
                    Store.dispatch("Login/getUser").then(response => {
                        if (response.perfil != 'Administrador') {
                            next("/401")
                        } else {
                            next();
                        }
                    });
                }
            },
            {
                path: "/visualizar-planos",
                meta: {
                    name: "",
                    requiresAuth: true
                },
                component: () => import("../views/VisualizarPlanos/VisualizarPlanos"),
                beforeEnter: (to, from, next) => {
                    Store.dispatch("Login/getUser").then(response => {
                        if (response.perfil != 'Administrador') {
                            next("/401")
                        } else {
                            next();
                        }
                    });
                }
            },
            {
                path: "/401",
                name: "401",
                component: () => import("../views/Unauthorized")
            }
        ]
    },
    {
        path: "/relatorio",
        meta: {
            name: "",
            requiresAuth: true
        },
        component: () => import("../views/Graficos/Relatorio")
    },
    {
        path: "/relatorio-quantitativo",
        meta: {
            name: "Relatorio Quantitativo Impressao",
            requiresAuth: true
        },
        component: () => import("../views/Relatorios/quantitativo/RelatorioQuantitativo.vue")
    },
    {
        path: "/relatorio-rendimento",
        meta: {
            name: "Relatorio de Rendimento Impressao",
            requiresAuth: true
        },
        component: () => import("../views/Relatorios/rendimento/RelatorioRendimento.vue")
    },
    {
        path: "/relatorio-participacao",
        meta: {
            name: "Relatorio de Participacao Impressao",
            requiresAuth: true
        },
        component: () => import("../views/Relatorios/participacao/RelatorioParticipacao.vue")
    },
    {
        path: "/relatorio-proficiencia-aluno-v2",
        meta: {
            name: "Relatorio Proficiencia Aluno V2 Impressao",
            requiresAuth: true
        },
        component: () => import("../views/Relatorios/proficiencia-aluno-v2/RelatorioProficienciaAlunoV2.vue"),
        beforeEnter: autorizarPerfisRelatorioProficienciaV2
    },
    {
        path: "/relatorio-proficiencia-turma-v2",
        meta: {
            name: "Relatorio Proficiencia Turma V2 Impressao",
            requiresAuth: true
        },
        component: () => import("../views/Relatorios/proficiencia-turma-v2/RelatorioProficienciaTurmaV2.vue"),
        beforeEnter: autorizarPerfisRelatorioProficienciaV2
    },
    {
        path: "/relatorio-proficiencia-escola-v2",
        meta: {
            name: "Relatorio Proficiencia Escola V2 Impressao",
            requiresAuth: true
        },
        component: () => import("../views/Relatorios/proficiencia-escola-v2/RelatorioProficienciaEscolaV2.vue"),
        beforeEnter: autorizarPerfisRelatorioProficienciaV2
    },
    {
        path: "/relatorio-proficiencia-rede-v2",
        meta: {
            name: "Relatorio Proficiencia Rede V2 Impressao",
            requiresAuth: true
        },
        component: () => import("../views/Relatorios/proficiencia-rede-v2/RelatorioProficienciaRedeV2.vue"),
        beforeEnter: autorizarPerfisRelatorioProficienciaV2
    },
    {
        path: "/relatorio-evolucao",
        meta: {
            name: "Relatorio de Evolucao Impressao",
            requiresAuth: true
        },
        component: () => import("../views/Relatorios/evolucao/RelatorioEvolucao.vue")
    },
    {
        path: "/relatorio-comparativo-escolas",
        meta: {
            name: "Relatorio Comparativo de Escolas Impressao",
            requiresAuth: true
        },
        component: () => import("../views/Relatorios/comparativo-escolas/RelatorioComparativoEscolas.vue")
    },
    {
        path: "/relatorio-proficiencia-questao",
        meta: {
            name: "Relatorio Proficiencia por Questao Impressao",
            requiresAuth: true
        },
        component: () => import("../views/Relatorios/proficiencia-questao/RelatorioProficienciaQuestao.vue")
    },
    {
        path: "/relatorio-proficiencia-por-escola",
        meta: {
            name: "Relatorio Proficiencia por Escola Impressao",
            requiresAuth: true
        },
        component: () => import("../views/Relatorios/proficiencia-por-escola/RelatorioProficienciaPorEscola.vue")
    },
    {
        path: "/teste",
        meta: {
            name: "",
            requiresAuth: true
        },
        component: () => import("../views/Teste")
    },
    {
        path: "/login",
        meta: {
            name: "",
            requiresAuth: false
        },
        name: "Login",
        component: () => import("../views/Login"),
        beforeEnter: (to, from, next) => {
            if (Store.getters["Login/authorized"]) {
                next("/");
            } else {
                next();
            }
        }
    },
    {
        path: "/politica-privacidade",
        meta: {
            name: "",
            requiresAuth: false
        },
        name: "PoliticaPrivacidade",
        component: () => import("../views/PoliticaPrivacidade")
    },
    {
        path: "/loja-aplicativo",
        meta: {
            name: "",
            requiresAuth: false
        },
        name: "Loja de Aplicativo",
        component: () => import("../views/LojaAplicativo")
    },
     {
        path: "/contato",
        meta: {
            name: "",
            requiresAuth: false
        },
        name: "Contato",
        component: () => import("../views/Contato")
    },
    {
        path: "/noticias/publico/:id",
        meta: {
            name: "Visualização de Notícia",
            requiresAuth: false
        },
        name: "NoticiaPublica",
        component: () => import("../views/Noticias/NoticiaPublica.vue")
    },
    {
        path: "*",
        meta: {
            name: "",
            requiresAuth: false
        },
        component: () => import("../views/NotFound")
    }

]

const router = new VueRouter({
    mode: 'history',
    routes,
    scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition;
      } else {
        return { x: 0, y: 0 };
      }
    }
})

router.beforeEach(async (to, from, next) => {
    const ticket = to.query['ticket'];
    if (ticket) {
        try {
            let baseUrl = process.env.VUE_APP_BACK_API || "http://localhost:4445";
            if (typeof window !== "undefined" && window.location && window.location.hostname) {
                const hostname = window.location.hostname;
                if (hostname !== "localhost" && hostname !== "127.0.0.1") {
                    baseUrl = baseUrl.replace("localhost", hostname).replace("127.0.0.1", hostname);
                }
            }
            const response = await HttpService.backApi.post(`${baseUrl}/auth/ticket/consumir/${ticket}`);
            if (response && response.data && response.data.access_token) {
                Store.dispatch("Login/saveToken", response.data.access_token);
            }
        } catch (e) {
            console.log(e)
        }
    }

    const token = to.query['auth_token'];
    if (token) {
        Store.dispatch("Login/saveToken", token);
    }

    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (Store.getters["Login/authorized"]) {
            next();
        } else {
            next("/login");
        }
    } else {
        next();
    }
});

export default router
